<template>
  <div name="hrms18x-search-box-index" class="hrms18x-search-box-index clearfix">
    <div :class="[searchboxDisp == true ? 'search-group-wrapper' : 'search-group-wrapper-min']">
      <div ref="searchboxWrapper" class="toggle-wrapper clearfix" @click="toggleSearchboxDisp()">
          <div class="search-ico"><i class="fa fa-search"></i></div>
          <div class="search-label" v-show="searchboxDisp"> {{ button.search }} </div>
          <div class="close-ico" v-show="searchboxDisp"><i class="fa fa-times"></i></div>
      </div>
      <div ref="searchboxPanel" class="search-box-panel clearfix" v-show="searchboxDisp">
    		<hrms-search-box
                  v-model="inputSearch"
	                :receivedStore="receivedStore"
	                :nowLang="nowLang"
	                :searchBoxAlias="searchBoxAlias"
                  @setLoadingParentBool="loadingParentBool = arguments[0]"
                  @setPreLoadParentBool="preLoadParentBool = arguments[0]" />
      </div>
    </div>

    <div ref="table" class="clearfix" :class="[searchboxDisp == true ? 'table-box-wrapper' : 'table-box-wrapper-full']">
	    <input-parent-typework v-show="false"
                             :labels="labels"
                             :searchIndex="searchIndex"
                             :traditionalDayLists="traditionalDayLists"
                             :shutdownDayLists="shutdownDayLists"
                             :parentCurrentDay="parentCurrentDay"
                             :parentCurrentTypework="parentCurrentTypework"
                             :parentTargetTypework="parentTargetTypework"
                             :setParentTypeworkToTargetTypework="setParentTypeworkToTargetTypework" />
      <hrms-table v-show="false"
                  :data="parentData"
                  style="min-height: 300px;"
                  @setLoadingParentBool="loadingParentBool = arguments[0]"
                  :loadingParentBool="loadingParentBool"
                  :preLoadParentBool="preLoadParentBool"
                  :nowLang="nowLang"
                  :maxRowspan="maxRowspan"
                  :searchDisp="parentSearchDisp"
                  :sortDisp="parentSortDisp" 
                  :editInlineEventBool="parentEditInlineEventBool"
                  :rowDisableCondition="parentRowDisableCondition"
                  :columns="parentColumns"
                  :columnEvent="parentColumnEvent"
                  :editEvent="parentEditEvent"
                  :selectEvent="setIndexChildByParent"
                  :confirmSelectBtnDisp="false"
                  :saveInlineBtnDisp="parentSaveInlineBtnDisp"
                  :saveInlineEvent="parentCallSave"
                  @tableValid="parentValid = arguments[0]"
                  ref="parentTable" />

      <input-child-typework  :labels="labels"
                             :searchIndex="searchIndex"
                             :traditionalDayLists="traditionalDayLists"
                             :shutdownDayLists="shutdownDayLists"
                             :childCurrentDay="childCurrentDay"
                             :childCurrentTypework="childCurrentTypework"
                             :childTargetTypework="childTargetTypework"
                             :setChildTypeworkToTargetTypework="setChildTypeworkToTargetTypework" />
	    <hrms-table :data="childData"
                  style="min-height: 688px;"
                  @setLoadingChildBool="loadingParentBool = arguments[0]"
                  :loadingParentBool="loadingParentBool"
                  :preLoadParentBool="preLoadParentBool"
                  :nowLang="nowLang"
                  :maxRowspan="maxRowspan"
                  :searchDisp="childSearchDisp"
                  :sortDisp="childSortDisp"
                  :editInlineEventBool="childEditInlineEventBool"
                  :rowDisableCondition="childRowDisableCondition"
                  :columns="childColumns"
                  :columnEvent="childColumnEvent"
                  :editEvent="childEditEvent"
                  :saveInlineEvent="childCallSave"
                  :saveInlineBtnDisp="false"
                  @tableValid="childValid = arguments[0]"
                  ref="childTable" />
    <div class="box-footer" v-if="!preLoadParentBool && !loadingParentBool && childSaveInlineBtnDisp">
      <button type="button" class="btn bg-color-skin" @click="saveIndex()" value="Save"><i class="fa fa-check-circle"></i>{{ labelsButton['save'] }}</button>
    </div>
    </div> 
  </div>
</template>

<script>
import bus from 'assets/js/bus'
import labels from 'src/../config/label'
import { constLabels } from 'assets/js/constLabels.js'
import inputParentTypework from 'components/hrms18e/inputParentTypework'
import inputChildTypework from 'components/hrms18e/inputChildTypework'
import swal from 'sweetalert'

export default {
  name: 'hrms18x-search-box-index',
  data () {
    return {
      parentValid: true,
      childValid: true,
      loadingParentBool: true,
      searchboxDisp: true,
      inputSearch: this.value,
      preLoadParentBool: this.unLoadBool
    }
  },
  methods: {
    toggleSearchboxDisp () {
      this.searchboxDisp = !this.searchboxDisp
    },
    parentCallSave (dataRowsHasFlg) {
      this.setParentInlineData(dataRowsHasFlg)
    },
    childCallSave (dataRowsHasFlg) {
      this.setChildInlineData(dataRowsHasFlg)
    },
    saveIndex () {
      this.$refs.parentTable.$emit('$saveInlineEventBuiltIn')
      this.$refs.childTable.$emit('$saveInlineEventBuiltIn')
      let _this = this
      swal({
        title: constLabels('confirmTitle'),
        text: constLabels('msgConfirmSave'),
        showCancelButton: true,
        closeOnConfirm: false,
        closeOnCancel: true,
        html: true
      },
      function (isConfirm) {
        if (isConfirm) {
          if (_this.parentValid && _this.childValid) {
            _this.loadingParentBool = true
            swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false})
            _this.postIndex({
              searchIndex: _this.inputSearch,
              sendParams: {
                parent: _this.parentInlineData,
                child: _this.childInlineData
              }
            })
          } else {
            swal.close()
          }
        }
      })
    }
  },
  watch: {
    inputSearch (newVal) {
      this.$emit('input', newVal)
    },
    unLoadBool () {
      this.preLoadParentBool = this.unLoadBool
    }
  },
  mounted () {
    bus.$on('veeValidate', () => {
      this.$validator.validateAll().then(result => {
        this.$emit('validateEvent', result)
      }).catch(result => {
        this.$emit('validateEvent', false)
      })
    })
  },
  props: {
    button: {
      type: Object
    },
    nowLang: {
      type: String,
      default: labels.defaultLang
    },
    maxRowspan: {
      type: Number,
      default: 1
    },
    labels: {
      type: Object
    },
    labelsButton: {
      type: Object
    },
    searchBoxAlias: {
      type: String
    },
    searchIndex: {
      type: Object
    },
    traditionalDayLists: {
      type: Array
    },
    shutdownDayLists: {
      type: Array
    },
    receivedStore: {
      type: Function,
      required: true
    },
    parentData: {
      type: Object,
      required: true
    },
    parentColumns: {
      type: Array,
      required: true
    },
    parentEditEvent: {
      type: Function
    },
    parentColumnEvent: {
      type: Function
    },
    parentEditInlineEventBool: {
      type: Boolean,
      default: false
    },
    parentSaveInlineBtnDisp: {
      type: Boolean,
      default: true
    },
    parentSearchDisp: {
      type: Boolean,
      default: true
    },
    parentSortDisp: {
      type: Boolean,
      default: true
    },
    parentRowDisableCondition: {
      type: Function
    },
    parentCurrentTypework: {
      type: String
    },
    parentTargetTypework: {
      type: String
    },
    parentCurrentCodshift: {
      type: String
    },
    parentTargetCodshift: {
      type: String
    },
    parentCurrentDay: {
      type: String
    },
    setParentCurrentTypework: {
      type: Function
    },
    setParentTargetTypework: {
      type: Function
    },
    setParentCurrentCodshift: {
      type: Function
    },
    setParentTargetCodshift: {
      type: Function
    },
    setParentTypeworkToTargetTypework: {
      type: Function
    },
    setParentInlineData: {
      type: Function
    },
    parentInlineData: {
      type: Array
    },
    setIndexChildByParent: {
      type: Function
    },
    childData: {
      type: Object,
      required: true
    },
    childColumns: {
      type: Array,
      required: true
    },
    childEditEvent: {
      type: Function
    },
    childAddInlineEventBool: {
      type: Boolean,
      default: false
    },
    childAfterAddInlineEvent: {
      type: Function
    },
    childColumnEvent: {
      type: Function
    },
    childEditInlineEventBool: {
      type: Boolean,
      default: false
    },
    childDeleteInlineEventBool: {
      type: Boolean,
      default: false
    },
    childDeleteInlineBtnDisabledOlds: {
      type: Boolean,
      default: false
    },
    childSaveInlineBtnDisp: {
      type: Boolean,
      default: true
    },
    childSearchDisp: {
      type: Boolean,
      default: true
    },
    childSortDisp: {
      type: Boolean,
      default: true
    },
    childRowDisableCondition: {
      type: Function
    },
    childCurrentTypework: {
      type: String
    },
    childTargetTypework: {
      type: String
    },
    childCurrentCodshift: {
      type: String
    },
    childTargetCodshift: {
      type: String
    },
    childCurrentDay: {
      type: String
    },
    setChildCurrentTypework: {
      type: Function
    },
    setChildTargetTypework: {
      type: Function
    },
    setChildCurrentCodshift: {
      type: Function
    },
    setChildTargetCodshift: {
      type: Function
    },
    setChildTypeworkToTargetTypework: {
      type: Function
    },
    setChildInlineData: {
      type: Function
    },
    childInlineData: {
      type: Array
    },
    value: {
      type: Object,
      default () {
        return {}
      }
    },
    postIndex: {
      type: Function
    },
    unLoadBool: {
      type: Boolean,
      default: false
    },
    saveBtnSearchBoxTable: {
      type: Boolean,
      default: false
    }
  },
  components: {
    inputParentTypework,
    inputChildTypework
  }
}
</script>

<style lang="scss">

.hrms18x-search-box-index {
  width: 100%;
  background: #FFF;
  box-shadow: 0 1px 1px 0 rgba(0,0,0,0.3);
  position: relative;

  @media (max-width: 768px) {
    display: block;
  }

  .search-group-wrapper {
    width: 250px;
    position: absolute;
    animation-name: search-resize-max;
    animation-duration: .2s;
    height: 100%;
    background: #F5F5F5;
    min-height: 660px;
    animation-duration: .4s;

    @media (max-width: 768px) {
      width: 100%;
      float: none;
      display: block;
      position: relative;
      min-height: auto;
      animation-name: none;
    }

    .toggle-wrapper {
      width: 100%;
      background: #F5F5F5;
      padding: 8px 15px 5px 13px;
      color: #757575;
      font-size: 18px;
      cursor: pointer;
      border-bottom: 1px solid #d2d6de;

      .search-ico {
        float: left;
      }

      .search-label {
        float: left;
        font-size: 16px;
        font-weight: 700;
        padding: 1px 0 0 5px;
      }

      .close-ico {
        float: right;
      }
    }
  }
  .search-group-wrapper-min {
    width: 45px;
    float: left;

    @media (max-width: 768px) {
      width: 100%;
      float: none;
      display: block;
    }

    .toggle-wrapper {
      width: 100%;
      padding: 8px 15px 5px 13px;
      color: #757575;
      font-size: 18px;
      cursor: pointer;

      .search-ico {
        float: left;
      }

      .search-label {
        float: left;
        font-size: 16px;
        font-weight: 700;
        padding: 1px 0 0 5px;
      }

      .close-ico {
        float: right;
      }
    }
  }

  .search-box-panel {
    // width: 100%;
    // height: auto;
    // background: #F5F5F5;
    // box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.3);
    // min-height: 660px;
    // animation-duration: .4s;

    @media (max-width: 768px) {
      min-height: 0;
      display: block;
    }
  }
  .table-box-wrapper {
    width: 100%;
    padding-left: 250px;
    background: #FFF;
    height: 100%;
    min-height: 660px;

    @media (max-width: 768px) {
      width: 100%;
      padding-left: 0px;
      float: none;
      display: block;
      min-height: 300px;
    }
  }
  .table-box-wrapper-full {
    width: 100%;
    padding-left: 45px;
    background: #FFF;
    height: 100%;
    min-height: 660px;

    @media (max-width: 768px) {
      width: 100%;
      padding-left: 0px;
      float: none;
      display: block;
    }
  }
}

@keyframes search-resize-max {
  0% {
    width: 50px;
  }
  100% {
    width: 250px;
  }
}

</style>



// WEBPACK FOOTER //
// searchBoxIndex.vue?4dff6baa